import { useTranslation } from "react-i18next";
import { useAddSavedForLaterItemMutation } from "../api/savedForLaterApi";
import { useMutationWithFeedback } from "../../../../common/hooks/useMutationWithFeedback";

/**
 * A custom hook to encapsulate the logic for adding an item to the 'Saved for Later' list.
 */
export const useAddToSavedForLater = () => {
  const { t } = useTranslation();
  const [addSavedItem, result] = useAddSavedForLaterItemMutation();

  const { trigger: handleAddToSavedForLater, isLoading: isAdding } =
    useMutationWithFeedback<number[], number>({
      mutation: [addSavedItem, result],
      loadingMessage: t(
        "feedback.savedForLater.loading",
        "Updating saved items..."
      ),
      successMessage: t(
        "feedback.savedForLater.addedSuccess",
        "Saved for later!"
      ),
      errorMessages: {
        default: t(
          "feedback.savedForLater.error",
          "Failed to save item. Please try again."
        ),
      },
      successToastType: "success",
    });

  return {
    handleAddToSavedForLater,
    isAdding,
  };
};
